export const monthArray = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

export const daysArray = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
